import styled from "styled-components";
import { Modal } from "semantic-ui-react";

export const Container = styled.div`
  padding: 1rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  div {
    display: flex;
    gap: 8px;
  }

  button.button-primary {
    background-color: #fff;
    color: var(--color-primary);
    font-size: 16px;
    line-height: normal;
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 4px;
    border: 1px solid var(--color-primary);

    &:hover {
      background-color: var(--color-primary);
      color: #fff;
    }
  }
  button.button-green {
    background-color: #90ee90;
    color: #fff;
    font-size: 16px;
    line-height: normal;
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 4px;
    border: 1px solid #5dd55d;

    &:hover {
      background-color: #5dd55d;
      color: #fff;
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button,
  a {
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

export const ButtonPagination = styled.button`
  background-color: #d3d3d3;
  border: none;
  cursor: pointer;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  color: #fff;

  ${(props) => props.active && `background-color: #fff;`}
  ${(props) => props.active && `border: 1px solid var(--color-primary);`}
  ${(props) => props.active && `color: var(--color-primary);`}
`;

export const StyledModal = styled(Modal)`
  padding: 30px;
  background: white;
  max-height: 600px;
  overflow-y: scroll;
  h3 {
    padding: 0;
    margin: 0;
    margin-bottom: 15px;
  }
`;

export const FormField = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
